import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

import { get, post } from 'helpers/api';
import SignCaPdf from './sign_ca_pdf';
import SignCaText from './sign_ca_text';
import FastSignCaText from './fast_sign_ca_text';
import { getProfileData } from '../../helpers/preview';

export default function SignCa({
  caPath,
  fastTrackProfilePath,
  readonly,
  signCaPath,
  trackViewedCaPath,
  onFastCaUnsupported,
  onNext,
}) {
  const [caData, setCaData] = useState({
    caFilePath: '',
    caText: '',
    caType: '',
    isFastCa: null,
    requiredName: ''
  });

  React.useEffect(() => {
    const pathName = window.location.pathname;
    const hasViewed = sessionStorage.getItem(`viewed_ca_${pathName}`);

    if (!hasViewed) {
      post(trackViewedCaPath).then(() => {
        sessionStorage.setItem(`viewed_ca_${pathName}`, true);
      });
    }

    get(caPath, { params: { readonly, previewProfile: getProfileData() } })
      .then((data) => {
        const {
          ca, file, isFastCa, caType, requiredName, caTypeStandard, caTypeCustomText, caTypeCustomPdf, caTypeCustomWord
        } = data;
        setCaData({
          caText: ca,
          caFilePath: file,
          isFastCa,
          caType,
          requiredName,
          caTypeStandard,
          caTypeCustomText,
          caTypeCustomPdf,
          caTypeCustomWord
        });
      })
      .catch((error) => {
        /* eslint-disable no-console */
        if (error.response.data?.error === 'fast_track_not_supported') {
          console.warn('fast track not supported; redirecting to normal flow');
          if (onFastCaUnsupported) onFastCaUnsupported();
        } else {
          console.error('fetch ca failed', { message: error.message, data: error.response.data });
        }
        /* eslint-enable no-console */
      });
  }, []);

  const { caFilePath, caText, caType, isFastCa, requiredName } = caData;

  if (!caText && !caFilePath) {
    return (
      <div className="text-center">
        <FontAwesomeIcon icon={faSpinner} size="2x" spin={true}/>
      </div>
    );
  }

  if (caFilePath) {
    return (
      <SignCaPdf
        caFiles={[{ type: caType, path: caFilePath }]}
        readonly={readonly}
        signCaPath={signCaPath}
        onNext={onNext}
      />
    );
  } else if (isFastCa) {
    return (
      <FastSignCaText
        caText={caText}
        fastTrackProfilePath={fastTrackProfilePath}
        signCaPath={signCaPath}
        onNext={onNext}
      />
    );
  } else {
    return (
      <SignCaText
        caText={caText}
        name={requiredName}
        readonly={readonly}
        signCaPath={signCaPath}
        onNext={onNext}
      />
    );
  }
}

SignCa.propTypes = {
  caPath: PropTypes.string.isRequired,
  fastTrackProfilePath: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  signCaPath: PropTypes.string.isRequired,
  onFastCaUnsupported: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired
};
